<template></template>

<script>
import userMixin from '@/mixins/user'
const crypto = require('crypto')

export default {
  name: 'Tawkto',
  mixins: [userMixin],
  mounted() {

    if (process.env.VUE_APP_APP_NAME == 'vinovibes' && process.env.VUE_APP_ENV != 'development') {
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();

      /** @TODO - Activate secure mode */
      if (this.user) {
        Tawk_API.visitor = {
          name : `${this.user.firstname} ${this.user.lastname}`,
          email : this.userEmail,
          // hash : crypto
          // .createHmac('sha1', process.env.VUE_APP_TAWKTO_API_KEY)
          // .update(this.userEmail)
          // .digest('hex')
        };
      }
      // create tawkto component
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/6093ebe4b1d5182476b64264/1f50t2u0s';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
    }
  }
}
</script>